const MINIMIZED_KEY = 'startscreen-layout:debugger-minimized'
const EVENT_NAME = 'startscreenLayoutDebugger:minimizedChanged'

function safeGetItem(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

function safeSetItem(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    // ignore
  }
}

export function getLayoutDebuggerMinimized(): boolean {
  if (typeof window === 'undefined') return false
  const raw = safeGetItem(MINIMIZED_KEY)
  if (raw === '1' || raw === 'true') return true
  if (raw === '0' || raw === 'false') return false
  return false
}

export function setLayoutDebuggerMinimized(minimized: boolean): void {
  if (typeof window === 'undefined') return
  safeSetItem(MINIMIZED_KEY, minimized ? '1' : '0')
  try {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { minimized } }))
  } catch {
    // ignore
  }
}

export function subscribeLayoutDebuggerMinimized(
  onChange: (minimized: boolean) => void
): () => void {
  if (typeof window === 'undefined') return () => {}

  const onCustomEvent = (e: Event) => {
    const ce = e as CustomEvent<{ minimized?: boolean }>
    if (typeof ce.detail?.minimized === 'boolean') onChange(ce.detail.minimized)
  }

  const onStorage = (e: StorageEvent) => {
    if (e.key !== MINIMIZED_KEY) return
    onChange(getLayoutDebuggerMinimized())
  }

  window.addEventListener(EVENT_NAME, onCustomEvent as EventListener)
  window.addEventListener('storage', onStorage)

  return () => {
    window.removeEventListener(EVENT_NAME, onCustomEvent as EventListener)
    window.removeEventListener('storage', onStorage)
  }
}
